// Project: GSSC Pilot Front-end
// Filename: datasets.js
// Copyright European Space Agency, 2020
// This file is part of the source code package for contract PO PO 5001024866
// No part of the package, including this file, may be copied, modified,
// propagated, or distributed without prior approval by ESA.

// defines the order of the columns in the datasets table
export function getSelectableColumns() {
  return [
    'ID',
    'Dataset',
    'Collection',
    'Access Policy',
    // 'Collaboration Plan',
    'Datalabs',
    'Dataset Type',
    'Comments',
    'Description',
    // 'Development Cost',
    // 'Development Plan',
    'DOI',
    // 'In Space',
    'Integration Plan',
    'License',
    'Memory Estimation',
    'Metadata',
    // 'Mission',
    'Network / Organisation',
    'Number Of Cores',
    'Points Of Contact',
    'Resource Type',
    // 'Resource Type Id',
    'Viewer Role',
    'Contributor Role',
    // 'Role Id',
    'Source',
    // 'Source Id',
    'Source Location',
    // 'Status',
    'Storage Estimation',
    'Subpaths',
    'Target Location'
    // 'Use Cases'
    // 'ID',
    // 'Name',
    // 'Description',
    // 'Asset Type',
    // 'Class',
    // 'Datalabs',
    // 'Access Policy',
    // 'Role',
    // 'License',
    // 'Integration Plan',
    // 'Repository',
    // 'Source Location',
    // 'Target Location',
    // 'Organisation',
    // 'Points Of Contact',
    // 'Development Plan',
    // 'Tags',
    // 'In Space',
    // 'Domains',
    // 'Dataset',
    // 'Mission',
    // 'Status',
    // 'Comments'
    // // 'Collaboration Plan',
    // // 'Development Cost',
    // // 'Memory Estimation',
    // // 'Number Of Cores',
    // // 'Storage Estimation',
    // // 'Use Cases'
  ];
}
// defines the columns that can be accessed by all users
export function getPublicColumns() {
  return [
    // 'ID',
    'Dataset',
    'Collection',
    'Access Policy',
    'Datalabs',
    // 'Dataset Type',
    'DOI',
    'Comments',
    'Description',
    // 'In Space',
    // 'Integration Plan',
    'License',
    'Metadata',
    // 'Mission',
    'Network / Organisation',
    'Resource Type'
    // 'ID',
    // 'Name',
    // 'Description',
    // // 'Asset Type',
    // 'Access Policy',
    // 'License',
    // // 'Tags',
    // 'Comments'
  ];
}

// defines the columns that are Array type
export function getArrayFields() {
  return [
    'Datalabs',
    // 'In Space',
    'Network / Organisation',
    'Points Of Contact',
    'Resource Type',
    'Resource Type Id',
    'Viewer Role',
    'Viewer Role Id',
    'Contributor Role',
    'Contributor Role Id',
    'Source',
    'Source Id',
    'Source Location',
    'Subpaths'
    // 'Use Cases'
    // 'Asset Type',
    // 'Datalabs',
    // 'DOI',
    // 'Domains',
    // 'In Space',
    // 'Tags',
    // 'Organisation',
    // 'Points Of Contact',
    // 'Repository',
    // 'Role',
    // 'Use Cases'
  ];
}

// defines the mapping between column name and API field
export function getDataMapping() {
  return {
    ID: 'dataset_id',
    Dataset: 'dataset_name',
    Collection: 'collection_name',
    'Access Policy': 'access_policy',
    // 'Collaboration Plan': 'collaboration_plan',
    Datalabs: 'dataset_datalabs',
    'Dataset Type': 'dataset_type',
    Comments: 'comments',
    Description: 'description',
    // 'Development Cost': 'development_cost',
    // 'Development Plan': 'development_plan',
    // 'In Space': 'in_space',
    'Integration Plan': 'integration_plan',
    License: 'license',
    'Memory Estimation': 'memory_estimation',
    Metadata: 'metadata',
    // Mission: 'mission',
    'Network / Organisation': 'network_organisation',
    'Number Of Cores': 'number_of_cores',
    'Points Of Contact': 'points_of_contact',
    'Resource Type': 'resource_type',
    // 'Resource Type Id': 'resource_type_id',
    'Viewer Role': 'viewer_role',
    'Contributor Role': 'contributor_role',
    // 'Role Id': 'role_id',
    Source: 'source',
    // 'Source Id': 'source_id',
    'Source Location': 'source_location',
    // Status: 'status',
    'Storage Estimation': 'storage_estimation',
    Subpaths: 'subpaths',
    'Target Location': 'target_location',
    // 'Use Cases': 'use_cases',
    // Description: 'description',
    // 'Asset Type': 'asset_type',
    // Class: 'class',
    // 'Access Policy': 'access_policy',
    // Role: 'role',
    // License: 'license',
    // 'Integration Plan': 'integration_plan',
    // Repository: 'repository',
    // 'Source Location': 'source_location',
    // 'Target Location': 'target_location',
    // Organisation: 'organisation',
    // 'Points Of Contact': 'points_of_contact',
    // 'Development Plan': 'development_plan',
    // Tags: 'tags',
    DOI: 'doi'
    // 'In Space': 'in_space',
    // Domains: 'domains',
    // Dataset: 'dataset',
    // Mission: 'mission',
    // Status: 'status',
    // Comments: 'comments'
    // // 'Collaboration Plan',
    // // 'Development Cost',
    // // 'Memory Estimation',
    // // 'Number Of Cores',
    // // 'Storage Estimation',
    // // 'Use Cases'
  };
}
export function sortableColumns() {
  return {
    ID: 'dataset_id',
    Dataset: 'dataset_name',
    Collection: 'collection_name',
    'Access Policy': 'access_policy',
    // 'Collaboration Plan': 'collaboration_plan',
    Datalabs: 'dataset_datalabs',
    'Dataset Type': 'dataset_type',
    DOI: 'doi',
    Comments: 'comments',
    Description: 'description',
    // 'Development Cost': 'development_cost',
    // 'Development Plan': 'development_plan',
    // 'In Space': 'in_space',
    'Integration Plan': 'integration_plan',
    License: 'license',
    'Memory Estimation': 'memory_estimation',
    Metadata: 'metadata',
    // Mission: 'mission',
    'Network / Organisation': 'network_organisation',
    'Number Of Cores': 'number_of_cores',
    'Points Of Contact': 'points_of_contact',
    'Resource Type': 'resource_type',
    // 'Resource Type Id': 'resource_type_id',
    'Viewer Role': 'viewer_role',
    'Contributor Role': 'contributor_role',
    // 'Role Id': 'role_id',
    Source: 'source',
    // 'Source Id': 'source_id',
    'Source Location': 'source_location',
    // Status: 'status',
    'Storage Estimation': 'storage_estimation',
    Subpaths: 'subpaths',
    'Target Location': 'target_location'
    // 'Use Cases': 'use_cases'
    // Name: 'name',
    // // 'Description': 'description',
    // 'Asset Type': 'asset_type',
    // Class: 'class',
    // 'Access Policy': 'access_policy',
    // Role: 'role',
    // License: 'license',
    // 'Integration Plan': 'integration_plan',
    // Repository: 'repository',
    // 'Source Location': 'source_location',
    // 'Target Location': 'target_location',
    // Organisation: 'organisation',
    // 'Points Of Contact': 'points_of_contact',
    // 'Development Plan': 'development_plan',
    // Tags: 'tags',
    // DOI: 'doi'
    // 'In Space': 'in_space',
    // Domains: 'domains',
    // Mission: 'mission',
    // Status: 'status'
    // // 'Comments':'comments',
    // // 'Collaboration Plan',
    // // 'Development Cost',
    // // 'Memory Estimation',
    // // 'Number Of Cores',
    // // 'Storage Estimation',
    // // 'Use Cases'
  };
}
